import React, { Component } from "react";
import Loading from "../../common/components/loading/loading";
import { getFilteredProductForMarket, refilterProductForMarketDateChange } from "../../common/services/products/productUtilities";
import { getVenue } from "../../common/services/markets/venueService";
import { getAggregateIndexBasesByMarket } from "../../common/services/marketdata/indexBaseService";
import { getTermSchedule } from "../../common/services/markets/termScheduleService";
import IndexDataTable from "./indexDataTable";
import { withTranslation } from "react-i18next";
import ListGroup from "react-bootstrap/ListGroup";
import Input from "../../common/components/form/input";

class IndexDataHeader extends Component {
  state = {
    marketAttributes: [],
    marks: [],
    indexBases: [],
    trades: [],
    marketPrices: [],
    isLoading: true,
    marketDate: null,
    fromDate: null,
    toDate: null,
    termScheduleId: null,
    originalQualityAttributeValues: null,
    filteredProduct: null,
    priceBasisId: null,
    currencyId: null,
    uomId: null,
    pricePrecision: 2,
    volumePrecision: 0,
    currencySymbol: "$",
  };

  async componentDidMount() {
    const { productId, market } = this.props;
    const { marketId } = market;

    let date = new Date();
    date.setMonth(date.getMonth());
    date.setDate(1);
    const marketDate = date.toLocaleDateString("fr-CA");

    const venue = await getVenue(market.venueId);
    const { originalQualityAttributeValues, filteredProduct } = 
      await getFilteredProductForMarket(productId, marketId, marketDate);

    const termSchedule = await getTermSchedule(market.termScheduleId);

    const timeZone =
      venue.timeZone +
      " (" +
      Intl.DateTimeFormat("us", {
        timeZoneName: "short",
        timeZone: venue.timeZone,
      })
        .formatToParts()
        .find((i) => i.type === "timeZoneName").value +
      ")";

    this.setState({
      marketDate: marketDate,
      originalQualityAttributeValues: originalQualityAttributeValues,
      filteredProduct: filteredProduct,
      marketAttributes: market.marketAttributes,
      termScheduleId: market.termScheduleId,
      forwardReportingPeriodicity: termSchedule.forwardReportingPeriodicity,
      historicalReportingPeriodicity:
        termSchedule.historicalReportingPeriodicity,
      priceBasisId: market.marketAttributes[0].priceBasisId,
      currencyId: market.marketAttributes[0].currencyId,
      uomId: market.marketAttributes[0].uomId,
      pricePrecision: market.marketAttributes[0].pricePrecision ?? 2,
      volumePrecision: market.marketAttributes[0].volumePrecision ?? 0,
      currencySymbol: market.marketAttributes[0].currencySymbol ?? "$",
      timeZone: timeZone,
      isLoading: false,
    });

    marketDate &&
      this.props.market &&
      termSchedule &&
      (await this.loadData(marketDate));
  }

  async loadData(marketDate) {
    //Set the fromMarketDate
    const fromDate = new Date(marketDate);
    fromDate.setMinutes(fromDate.getMinutes() + fromDate.getTimezoneOffset());

    const currentDate = new Date();
    const eomDate = new Date(
      fromDate.getFullYear(),
      fromDate.getMonth() + 1,
      0
    );
    //Get the end of the month for the from date, or the current date, whichever is earlier.
    const toDate = currentDate < eomDate ? currentDate : eomDate;

    this.setState({ fromDate: fromDate, toDate: toDate });

    const { market } = this.props;
    const { marketId } = market;

    await this.loadIndexBases(marketId, fromDate, toDate);
  }

  async loadIndexBases(marketId, fromDate, toDate) {
    const indexBasesRaw = await getAggregateIndexBasesByMarket(
      marketId,
      fromDate.toLocaleDateString("fr-CA"),
      toDate.toLocaleDateString("fr-CA")
    );

    const indexBases = indexBasesRaw.map((item) => ({
      ...item,
      termName: "Spot",
    }));

    this.setState({ indexBases: indexBases });
  }

  handleMarketDateChange = async (marketDate) => {
    // Update date immediately so input doesn't reset
    this.setState({ marketDate: marketDate });

    const { market } = this.props;
    const { marketId } = market;

    // Perform refiltering asynchronously in background
    refilterProductForMarketDateChange(this, marketDate, marketId);

    // Load data asynchronously (existing behavior)
    (async () => {
      await this.loadData(marketDate);
    })();
  };

  handlemarketAttributeSelect = (marketAttribute) => {
    this.setState({
      priceBasisId: marketAttribute.priceBasisId,
      currencyId: marketAttribute.currencyId,
      uomId: marketAttribute.uomId,
    });
  };

  getFilteredIndexBases() {
    const { indexBases, priceBasisId, uomId, currencyId } = this.state;

    const filteredIndexBases = indexBases.filter(
      (x) =>
        x.priceBasisId === priceBasisId &&
        x.uomId === uomId &&
        x.currencyId === currencyId
    );

    // const aggregatedIndexBases =
    //   this.aggregateIndexBasesByDay(filteredIndexBases);

    return { indexBases: filteredIndexBases };
  }

  // aggregateIndexBasesByDay(indexBases) {
  //   const grouped = indexBases.reduce((acc, row) => {
  //     //const dayKey = new Date(row.marketDate).toISOString().split("T")[0];
  //     const dayKey = row.marketDate;

  //     if (!acc[dayKey]) {
  //       acc[dayKey] = {
  //         marketDate: row.marketDate,
  //         marketName: row.marketName,
  //         // priceBasisId: row.priceBasisId,
  //         // priceBasisName: row.priceBasisName,
  //         termName: "Spot",

  //         markPriceSum: 0,
  //         markPriceCount: 0,

  //         bestBid: null,
  //         bestOffer: null,

  //         tradeVolumeSum: 0,
  //         tradeWeightedValueSum: 0,

  //         tradeCount: 0,
  //       };
  //     }

  //     const g = acc[dayKey];

  //     if (row.markPrice != null) {
  //       g.markPriceSum += Number(row.markPrice);
  //       g.markPriceCount += 1;
  //     }

  //     if (row.bestBid != null) {
  //       g.bestBid =
  //         g.bestBid == null
  //           ? Number(row.bestBid)
  //           : Math.max(g.bestBid, Number(row.bestBid));
  //     }

  //     if (row.bestOffer != null) {
  //       g.bestOffer =
  //         g.bestOffer == null
  //           ? Number(row.bestOffer)
  //           : Math.min(g.bestOffer, Number(row.bestOffer));
  //     }

  //     if (row.tradeVolume != null && row.tradeWeightedAverage != null) {
  //       const volume = Number(row.tradeVolume);
  //       g.tradeVolumeSum += volume;
  //       g.tradeWeightedValueSum += volume * Number(row.tradeWeightedAverage);
  //     }

  //     g.tradeCount += row.tradeCount ?? 0;

  //     return acc;
  //   }, {});

  //   return Object.values(grouped).map((g) => ({
  //     marketDate: g.marketDate,
  //     marketName: g.marketName,
  //     // priceBasisId: g.priceBasisId,
  //     // priceBasisName: g.priceBasisName,
  //     termName: g.termName,

  //     markPrice:
  //       g.markPriceCount > 0 ? g.markPriceSum / g.markPriceCount : null,

  //     bestBid: g.bestBid,
  //     bestOffer: g.bestOffer,

  //     tradeVolume: g.tradeVolumeSum || null,
  //     tradeWeightedAverage:
  //       g.tradeVolumeSum > 0
  //         ? g.tradeWeightedValueSum / g.tradeVolumeSum
  //         : null,

  //     tradeCount: g.tradeCount > 0 ? g.tradeCount : null,
  //   }));
  // }

  render() {
    const {
      timeZone,
      marketAttributes,
      termScheduleId,
      historicalReportingPeriodicity,
      isLoading,
      toDate,
      fromDate,
      marketDate,
      priceBasisId,
      currencyId,
      uomId,
      pricePrecision,
      volumePrecision,
      currencySymbol,
      filteredProduct,
    } = this.state;

    const product = filteredProduct;
    const { indexBases } = this.getFilteredIndexBases();

    if (isLoading) return <Loading />;

    const { t, market } = this.props;
    const marketName = (market?.name ?? market?.marketName ?? "").trim();
    const renderSectionTitle = (label) => (
      <span className="section-title-label">
        {label}
      </span>
    );

    var date = new Date();
    date.setMonth(date.getMonth());
    date.setDate(1);

    const endDate = date.toLocaleDateString("fr-CA").substring(0, 7);
    const monthValue = marketDate.substring(0, 7);

    return (
      <div className="container-fluid market-data-page">
        {marketName && <h1 className="market-name-page-title">{marketName}</h1>}
        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="selector-title-class">{t("PriceBasis")}</div>
            <ListGroup
              value={marketAttributes[0]}
              horizontal="sm"
              className="price-basis-selector"
            >
              {marketAttributes.map((attribute, index) => (
                <ListGroup.Item
                  className="market-attribute-selector"
                  key={index}
                  action
                  active={priceBasisId === attribute.priceBasisId}
                  onClick={() => this.handlemarketAttributeSelect(attribute)}
                >
                  {attribute.priceBasisName +
                    " (" +
                    attribute.currencyName +
                    "/" +
                    attribute.uomName +
                    ")"}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
          <div className="col-md-3"></div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <Input
              type="month"
              max={endDate}
              onChange={(e) =>
                this.handleMarketDateChange(e.currentTarget.value)
              }
              //name = "name"
              value={monthValue}
              label={
                <span className="selector-title-class">{t("MarketDate")}</span>
              }
            />
          </div>
          <div className="col-md-6"></div>
          <div className="col-md-3 align-self-start time-zone-block">
            <div className="selector-title-class time-zone-title">
              {t("TimeZone")}
            </div>
            <div>{timeZone}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 tile section-tile shadow-card">
            <h5 className="section-title">
              {renderSectionTitle(t("IndexBaseData"))}
            </h5>
            <IndexDataTable
              indexBases={indexBases}
              product={product}
              market={market}
              termScheduleId={termScheduleId}
              historicalReportingPeriodicity={historicalReportingPeriodicity}
              fromDate={fromDate}
              toDate={toDate}
              priceBasisId={priceBasisId}
              currencyId={currencyId}
              uomId={uomId}
              pricePrecision={pricePrecision}
              volumePrecision={volumePrecision}
              currencySymbol={currencySymbol}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation(["marketdata"])(IndexDataHeader);
